import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../store";
import { Button, PanelSlider } from "../../ui";
import cancelIcon from "../../../assets/images/close.svg";
import { setOpenDetailTabs } from "../../../reducers/tradeDetail_byId_slice";
import {
  getPaymentHistory,
  updatePaymentUpdateStatus,
} from "../../../reducers/arrivalDetails_slice";
import PaymentHistory from "../../../pages/trade-detail/payment-history";
import RecordPayment from "../../../pages/trade-detail_v2/payment_details/record_payment";
import {
  setNotification,
  setNotifiTabs,
  setOpenPaymentView,
  setOpenTradeDetails,
  setRefreshMovePmt,
  setSelectedDestTraderId,
  setSelectedPaymentId,
  setSelectTradeId,
  updateTradeId,
} from "../../../reducers/trade_details_Slice";
import { useNavigate } from "react-router-dom";
import { updateSelectedPaymentType } from "../../../reducers/paymentDetails_slice";
import { getCurrencyNumberWithSymbol } from "../../../helpers/get-currency-number";
import NodataAvailable from "../../../assets/images/NodataAvailable.svg";
import {
  setLoanId,
  setOpenLoansTabDetals,
  setOpenRepaymentTranscView,
  setPmtStatus,
  setRepayHistoryId,
  updateActiveLoanTypeTab,
} from "../../../reducers/loansSlice";
import { useUIPermissions } from "../../../layout/config/permissionUtils";

const Notifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    openTradeDetails,
    roleType,
    tradeId,
    traderId,
    notifications,
    notifiTabs,
  } = useSelector((state: TRootState) => ({
    openTradeDetails: state.tradeDetails.openTradeDetails,
    roleType: state.auth.userInfo.roleType,
    tradeId: state.tradeDetails.tradeId,
    traderId: state.tradeDetails.traderId,
    notifications: state.tradeDetails.notifications,
    notifiTabs: state.tradeDetails.notifiTabs,
  }));
  const [openRecordPayment, setOpenRecordPayment] = useState(false);
  const [openPaymenHistory, setOpenPaymenHistory] = useState(false);

  const panelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(event.target as Node)
      ) {
        setOpenRecordPayment(false);
        setOpenPaymenHistory(false);
      }
    };
    if (openRecordPayment || openPaymenHistory) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openRecordPayment, openPaymenHistory]);

  const tradeNotifications = notifications.filter((i) => i.product === "TRADE");
  const loanNotifications = notifications.filter((i) => i.product === "LOAN");
  const { hasAdminManagerEditAccess } = useUIPermissions();
  return (
    <>
      <div
        className={`flex w-full border-b justify-between transition-all duration-300 mb-4`}
      >
        <div className="flex gap-4 w-full">
          <span
            className={`fs-12 cursor-pointer relative py-2 px-2 ${
              notifiTabs === "trades" ? "color-primary" : "color-sub-text"
            }`}
            style={{ fontWeight: 700, fontSize: "12px" }}
            onClick={() => {
              dispatch(setNotifiTabs("trades"));
            }}
          >
            TRADES
            {notifiTabs === "trades" && (
              <span className="absolute bottom-0 left-0 h-[4px] bg-primary rounded-t-lg w-full"></span>
            )}
          </span>

          <span
            className={`fs-12 cursor-pointer relative py-2 px-2 ${
              notifiTabs === "loans" ? "color-primary" : "color-sub-text"
            }`}
            style={{ fontWeight: 700, fontSize: "12px" }}
            onClick={() => {
              dispatch(setNotifiTabs("loans"));
            }}
          >
            LOANS
            {notifiTabs === "loans" && (
              <span className="absolute bottom-0 left-0 w-full h-[4px] bg-primary rounded-t-lg"></span>
            )}
          </span>
        </div>
      </div>

      <div
        className="overflow-y-auto"
        style={{ height: "calc(100vh - 10rem)" }}
      >
        {notifiTabs === "trades" && (
          <>
            {tradeNotifications?.length > 0 && notifications ? (
              tradeNotifications?.map((item, i) => (
                <div className="flex border gap-4 items-center br-10 card_space_18 mb-3">
                  {item?.imgs?.length > 0 ? (
                    <div>
                      {item.imgs[0].url?.toLowerCase()?.includes(".pdf") ? (
                        <div className="w-24 h-24 flex flex-col items-center justify-center bg-gray-100 rounded border">
                          <svg
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <path d="M14 2v6h6" />
                          </svg>
                          <span className="text-[10px] text-gray-500 mt-1">
                            PDF
                          </span>
                        </div>
                      ) : (
                        <img
                          src={item.imgs[0].url}
                          className="w-24 h-24"
                          alt=""
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      className=" flex justify-center items-center bg-gray-light br-10 p-[10px] w-[100px] h-[100px] min-w-[100px] text-center cursor-pointer "
                      style={{
                        border: "1px dashed #595959",
                      }}
                    >
                      <span className="fs-12"> No Document Available</span>
                    </div>
                  )}
                  <div className="">
                    <p className="font-semibold text-sm">
                      {`New Payment has been recorded by ${item.destTradeNAme}`}
                    </p>
                    <div className="">
                      <span className="color-sub-text fs-12">Payment ID: </span>
                      <span className="color-blue font-medium fs-14">
                        {item.pmtId}{" "}
                      </span>{" "}
                      |{" "}
                      <span className="color-sub-text fs-12">
                        Trade ID:{" "}
                        <span className="color-blue font-medium fs-14">
                          {item?.tradeId}
                        </span>{" "}
                      </span>{" "}
                      |{" "}
                      <span className="color-sub-text fs-12">
                        Trader Name:{" "}
                      </span>
                      <span className="font-medium fs-14">
                        {item.destTradeNAme}
                      </span>
                    </div>

                    <div className="flex gap-2">
                      <span className="">
                        <span className="color-sub-text fs-12">
                          Amount Received:&nbsp;
                        </span>
                        <span className="font-medium fs-14">
                          {getCurrencyNumberWithSymbol(item.amount)} |{" "}
                        </span>
                      </span>

                      <span className="">
                        <span className="color-sub-text fs-12">
                          Payment Mode:&nbsp;
                        </span>
                        <span className="font-medium fs-14">
                          {item.pmtMode}
                        </span>
                      </span>
                    </div>

                    <div>
                      <span className="">
                        <span className="color-sub-text fs-12">
                          Payment Type:&nbsp;
                        </span>
                        <span className="font-medium fs-14">
                          {item.paymentType}
                        </span>
                      </span>
                    </div>

                    <div className="flex gap-4 py-2 bg-white">
                      <div>
                        <Button
                          text="View"
                          className=""
                          variant="gray"
                          onClick={() => {
                            dispatch(
                              updateTradeId({
                                tradeId: item.tradeId,
                                traderId: item.traderId,
                              }),
                            );
                            dispatch(setOpenPaymentView());
                            dispatch(setOpenTradeDetails(true));
                            dispatch(setNotification(false));
                            dispatch(setOpenDetailTabs("Payment Details"));
                            dispatch(setSelectTradeId(item.tradeId));
                            dispatch(setSelectedDestTraderId(item.traderId));
                            navigate("/trades");
                            dispatch(setSelectedPaymentId(item.pmtId));
                            dispatch(setRefreshMovePmt(true));
                          }}
                        ></Button>
                      </div>
                      {hasAdminManagerEditAccess && (
                        <div className="">
                          <Button
                            text="Edit Receipt"
                            className=""
                            onClick={() => {
                              navigate("/trades");
                              dispatch(
                                updateTradeId({
                                  tradeId: item.tradeId,
                                  traderId: item.traderId,
                                }),
                              );
                              dispatch(
                                getPaymentHistory({
                                  paymentHistoryObj: item,
                                }),
                              );
                              dispatch(
                                updatePaymentUpdateStatus({
                                  paymentUpdateStatus: true,
                                }),
                              );
                              dispatch(setNotification(false));
                              dispatch(setOpenTradeDetails(true));
                              dispatch(setOpenDetailTabs("Payment Details"));
                              dispatch(updateSelectedPaymentType("INWARD"));
                              dispatch(setSelectTradeId(item.tradeId));
                              dispatch(setSelectedDestTraderId(item.traderId));
                              dispatch(setSelectedPaymentId(item.pmtId));
                              dispatch(setRefreshMovePmt(true));
                            }}
                          ></Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex justify-center items-center h-full w-full bg-white py-4">
                <img src={NodataAvailable} alt="No Data" />
              </div>
            )}
          </>
        )}

        {/* LOANS PAYMENTS UIIIIIIII */}

        {notifiTabs === "loans" && (
          <>
            {loanNotifications?.length > 0 && notifications ? (
              loanNotifications?.map((data) => (
                <div className="border card_space_18 mb-3 rounded-lg">
                  <div className="flex items-center gap-4">
                    <div className="">
                      {data?.imgs?.length > 0 ? (
                        <div>
                          {data.imgs[0].url?.toLowerCase()?.includes(".pdf") ? (
                            <div className="w-24 h-24 flex flex-col items-center justify-center bg-gray-100 rounded border">
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                              >
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <path d="M14 2v6h6" />
                              </svg>
                              <span className="text-[10px] text-gray-500 mt-1">
                                PDF
                              </span>
                            </div>
                          ) : (
                            <img
                              src={data.imgs[0].url}
                              className="w-24 h-24"
                              alt=""
                            />
                          )}
                        </div>
                      ) : (
                        <div
                          className=" flex justify-center items-center bg-gray-light br-10 p-[5px] w-24 h-24  text-center cursor-pointer "
                          style={{
                            border: "1px dashed #595959",
                          }}
                        >
                          <span className="fs-12"> No Document Available</span>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col w-full">
                      <span className="fs-14">{`New Payment has been recorded by ${data?.destTradeNAme}`}</span>
                      <div className="">
                        <span className="color-sub-text fs-12">
                          Borower Name:{" "}
                        </span>
                        <span className="font-medium fs-14">
                          {data?.destTradeNAme}{" "}
                        </span>{" "}
                        |{" "}
                        <span className="color-sub-text fs-12">
                          Payment ID:{" "}
                          <span className="color-blue font-medium fs-14">
                            {data?.pmtId}
                          </span>{" "}
                        </span>{" "}
                        |{" "}
                        <span className="color-sub-text fs-12">Loan ID: </span>
                        <span className="color-blue font-medium fs-14">
                          {data?.tradeId}
                        </span>
                      </div>

                      <div className="">
                        <span className="color-sub-text fs-12">
                          Amount Received:{" "}
                        </span>
                        <span className="font-medium fs-14">
                          {getCurrencyNumberWithSymbol(data?.amount, true)}{" "}
                        </span>{" "}
                        |{" "}
                        <span className="color-sub-text fs-12">
                          Payment Mode:{" "}
                          <span className="font-medium fs-14">
                            {data?.pmtMode}
                          </span>{" "}
                        </span>
                      </div>

                      <div className="flex gap-4 py-2 bg-white">
                        <div>
                          <Button
                            text="View"
                            className=""
                            variant="gray"
                            onClick={() => {
                              navigate("/loans");
                              dispatch(updateActiveLoanTypeTab("LOANS"));
                              dispatch(setOpenLoansTabDetals(true));
                              dispatch(setLoanId(data?.tradeId.toString()));
                              // dispatch(setOpenRepaymentTranscView(true));
                              dispatch(setNotification(false));
                              dispatch(setRepayHistoryId(data?.pmtId));
                              dispatch(setPmtStatus(data?.pmtStatus));
                            }}
                          ></Button>
                        </div>
                        {hasAdminManagerEditAccess && (
                          <div className="">
                            <Button
                              text="Edit Receipt"
                              className=""
                              onClick={() => {
                                navigate("/loans");
                                dispatch(updateActiveLoanTypeTab("LOANS"));
                                dispatch(setNotification(false));
                                dispatch(setOpenLoansTabDetals(true));
                                dispatch(setLoanId(data?.tradeId.toString()));
                                dispatch(setOpenRepaymentTranscView(true));
                                dispatch(setRepayHistoryId(data?.pmtId));
                                dispatch(setPmtStatus(data?.pmtStatus));
                                // dispatch(setIsEditLoanPmt(true));
                              }}
                            ></Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex justify-center items-center h-full w-full bg-white py-4">
                <img src={NodataAvailable} alt="No Data" />
              </div>
            )}
          </>
        )}
      </div>

      <PanelSlider
        direction="right_to_left"
        open={openPaymenHistory}
        onClose={() => {
          setOpenPaymenHistory(false);
        }}
        style={{ width: "40vw" }}
      >
        <div
          className="py-6 px-4 border-b flex items-center justify-between panel-content"
          ref={panelRef}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            <h2> Payment Details</h2>
          </div>
          <div>
            <img
              src={cancelIcon}
              className="cursor-pointer"
              onClick={() => {
                setOpenPaymenHistory(false);
              }}
              alt=""
            />
          </div>
        </div>

        {openPaymenHistory === true && (
          <PaymentHistory
            traderId={traderId}
            tradeId={tradeId}
            onClose={() => {
              setOpenPaymenHistory(false);
            }}
            onEdit={() => {
              setOpenPaymenHistory(false);
              setOpenRecordPayment(true);
            }}
            role={roleType}
          />
        )}
      </PanelSlider>

      <PanelSlider
        direction="right_to_left"
        open={openRecordPayment}
        onClose={() => {
          setOpenRecordPayment(false);
        }}
        style={{ width: "40vw" }}
      >
        <div className="py-6 px-4 border-b flex items-center justify-between">
          <div>
            <h2>Record Payment</h2>
          </div>
          <div>
            <img
              src={cancelIcon}
              className="cursor-pointer"
              onClick={() => {
                setOpenRecordPayment(false);
              }}
              alt=""
            />
          </div>
        </div>

        {openRecordPayment === true && (
          <RecordPayment
            onClose={() => {
              setOpenRecordPayment(false);
            }}
          />
        )}
      </PanelSlider>
    </>
  );
};
export default Notifications;
